<template>
  <div>
    <div class="tabs-container">
      <button
        :data-testid="`${title}-tab`"
        v-for="{ title, component } in components"
        :key="title"
        @click="changeTab(component)"
        :class="{ active: currentComponent === component && components.length > 1}"
      >
        {{ title }}
      </button>
    </div>
    <component :is="currentComponent" v-bind="currentProperties" />
  </div>
</template>

<script>
import AllDestinations from './AllDestionations.vue'
import HotDestinations from './HotDestinations.vue'
import { createNamespacedHelpers } from 'vuex'
import { expiredOffer } from '@/infrastructure/Configuration'
const { mapGetters } = createNamespacedHelpers('offersDestinations')
export default {
  name: 'Tabs',
  components: {
    AllDestinations,
    HotDestinations
  },
  computed: {
    ...mapGetters(['selectedCode', 'offer']),
    currentProperties() {
      const props = {
        HotDestinations: {},
        AllDestinations: {}
      }

      return props[this.currentComponent]
    },
    emptyHotDestinations() {
      return this.offer.cities.length === 0
    }
  },
  created() {
    this.onDisplayTabs()
  },
  data() {
    return {
      components: [],
      currentComponent: '',
      expiredOffer: expiredOffer
    }
  },
  methods: {
    changeTab(tab) {
      this.currentComponent = tab
    },
    onDisplayTabs() {
      if (this.expiredOffer) {
        this.components = [{ title: this.translate('offAllDestinations'), component: AllDestinations }]
        this.currentComponent = AllDestinations
      } else {
        if (this.emptyHotDestinations) {
          this.components = [{ title: this.translate('offAllDestinations'), component: AllDestinations }]
          this.currentComponent = AllDestinations
        } else {
          this.components = [
            { title: this.translate('offHotDestinations'), component: HotDestinations },
            { title: this.translate('offAllDestinations'), component: AllDestinations }
          ]
          this.currentComponent = HotDestinations
        }
      }
    }
  },
  watch: {
    selectedCode() {
      this.currentComponent = AllDestinations
    }
  }
}
</script>

<style scoped lang="scss">
.tabs-container {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 2.5rem;
  button,
  .allDestinationStyle {
    border-top: 0 solid transparent;
    border-left: 0 solid transparent;
    border-right: 0 solid transparent;
    border-bottom: 1px solid color('grey-light');
    font-weight: 400;
    padding: 10px;
    background: white;
    color: color('dark-grey');
    &:hover {
      border-bottom: 1px solid color('rhg-red');
    }
    &:focus {
      outline: none;
      box-shadow: none;
    }
  }
  button.active {
    border-bottom: 1px solid color('rhg-red');
    color: black;
  }
  .allDestinationStyle{
    pointer-events: none;
  }
}
</style>
